export default __webpack_public_path__ + "images/svg-sprite/bg-video-controls/icon-control-mute.svg";